import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('authToken');

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/login');
  };

  // Don't show anything on the public clock display
  if (location.pathname.startsWith('/clock/')) {
    return null;
  }

  if (token) {
    return (
      <>
        <button
          onClick={() => window.__lockScreen && window.__lockScreen()}
          style={{
            background: '#444',
            color: 'white',
            border: 'none',
            padding: '6px 14px',
            borderRadius: '4px',
            cursor: 'pointer',
            margin: '0 10px'
          }}
        >
          🔒 Lock
        </button>
        <button
          onClick={handleLogout}
          style={{
            background: '#6c1313',
            color: 'white',
            border: 'none',
            padding: '6px 14px',
            borderRadius: '4px',
            cursor: 'pointer',
            margin: '0 10px'
          }}
        >
          🔒 Logout
        </button>
      </>
    );
  }

  return (
    <button
      onClick={() => navigate('/login')}
      style={{
        background: '#28a745',
        color: 'white',
        border: 'none',
        padding: '6px 14px',
        borderRadius: '4px',
        cursor: 'pointer',
        margin: '0 10px'
      }}
    >
      Login
    </button>
  );
};

export default AuthNav;